export const ROLE_PERMISSIONS = {
    addPartner: 'addPartner',
    viewPartner: 'viewPartner',
    editPartner: 'editPartner',
    changePartnerStatus: 'changePartnerStatus',
    addMerchant: 'addMerchant',
    cancelServices: 'cancelServices',
    addService: 'addService',
    viewMerchant: 'viewMerchant',
    editMerchant: 'editMerchant',
    changeMerchantStatus: 'changeMerchantStatus',
    unmaskPll: 'unmaskPll',
    leadManagement: 'leadManagement',
    pricingAndProductManagement: 'pricingAndProductManagement',
    reportingExcludingFinance: 'reportingExcludingFinance',
    reportingIncludingFinance: 'reportingIncludingFinance',
    stockManagement: 'stockManagement',
    viewFinance: 'viewFinance',
    viewCommissions: 'viewCommissions',
    viewSelfBillingInvoices: 'viewSelfBillingInvoices',
    addInvoice: 'addInvoice',
    addPayment: 'addPayment',
    addCredit: 'addCredit',
    partnerShop: 'partnerShop',
    serviceDesk: 'serviceDesk',
    configurationUserManagement: 'configurationUserManagement',
    configurationAuditLog: 'configurationAuditLog',
    configurationFinance: 'configurationFinance',
    configurationSage: 'configurationSage',
    managePartnerResources: 'managePartnerResources',
    configurationOther: 'configurationOther',
    customerSuccess: 'customerSuccess',
};
